import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { toast } from "react-toastify";
import "../../../styles/staff-onboarding/staff-onboarding.css";
import HelmetWrapper from "../../../HelmetWrapper";
import { onboarding_staff_types } from "../../common-data/DropdowData";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import {
  commonPostPutFormData,
  commonPostPutApi,
} from "../../../redux/reducers/commonApiSlice";
import {
  add_staff_onboarding,
  re_onboard_staff,
  update_staff_onboarding,
} from "../../../data/ApiEndpoints";
import {
  fetchTrainerExpertiesData,
  fetchReceptionistShiftsData,
  fetchTrainerCategoryData,
  fetchTrainerExperienceLevelData,
} from "../../../redux/reducers/dropdownApiSlice";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ViewOfferLetter from "./ViewOfferLetter";
import SubmissionThankYouPage from "../../Open-pages/common/SubmissionThankYouPage";
import {
  AlertIcon,
  CallIcon,
  EmailIcon,
  CheckIcon,
  XIcon,
} from "../../../images/icons/icons";
import ContactVerificationSection from "./sections/ContactVerificationSection";
import BasicInformationSection from "./sections/BasicInformationSection";
import BankingInformationSection from "./sections/BankingInformationSection";
import DocumentUploadSection from "./sections/DocumentUploadSection";
import FormInput from "./components/FormInput";
import SelectDropdown from "../../components-react/SelectDropdown";
import MultiSelect from "../../components-react/MultiSelect";
import { sortShiftsByStartTime } from "../on-boarding-requests/SortShifts";
import { convertTo12HourFormat } from "../../common-data/Converts";
import { addShiftAPI } from "../../../data/dropdownApiS";

const OnBoardingFormLanding = ({
  userInfoData,
  rowData,
  isEdit,
  isApproval,
  closeModal,
  callFunction,
  isReOnboard,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoadingFormData } = useSelector((state) => state.common);
  const {
    trainerExperties,
    receptionistShifts,
    trainerCategories,
    trainerExperienceLevel,
  } = useSelector((state) => state.dropdown);
  const formRef = useRef({});

  const isAdmin = userInfoData?.account_type === "admin";

  const getSelectedExperties = (rowData, trainerExperties) => {
    if (!rowData?.expertise || !rowData?.expertise_id) return [];

    const expertiseArray = rowData.expertise
      .split(",")
      .map((item) => item.trim());
    const expertiseIdArray = rowData.expertise_id
      .split(",")
      .map((item) => item.trim());
    const selectedExpertise = [];

    expertiseArray.forEach((expertise, index) => {
      const matchingExpertise = trainerExperties?.find(
        (exp) => exp.label.toLowerCase() === expertise.toLowerCase()
      );

      if (matchingExpertise) {
        selectedExpertise.push(matchingExpertise);
      } else {
        selectedExpertise.push({
          value: expertiseIdArray[index] || expertise,
          label: expertise,
        });
      }
    });

    return selectedExpertise;
  };

  const forminitials = {
    selectedStaffType: rowData?.account_type
      ? {
          value: rowData.account_type,
          label: rowData.account_type?.replace(/_/g, " "),
        }
      : "",
    selectedGym:
      rowData?.gym_id && rowData?.gym_name
        ? { value: rowData.gym_id, label: rowData.gym_name }
        : "",
    selectedGyms:
      rowData?.gyms_info?.length > 0
        ? gymData.filter((gym) =>
            rowData.gyms_info.some((info) => info.user_id === gym.value)
          )
        : [],
    staffName: rowData?.name || "",
    staffMobile: rowData?.mobile || "",
    staffEmail: rowData?.email || "",
    staffEmergencyContactNumber: rowData?.emergency_contact || "",
    joiningDate: rowData?.joining_date || "",
    staffDob: rowData?.dob || "",
    selectedExperties: getSelectedExperties(rowData, trainerExperties),
    fullAddress: rowData?.address || "",
    staffSalary:
      rowData?.salary && !isNaN(Number(rowData.salary)) ? rowData.salary : "",
    pinCode: rowData?.postal_code || "",
    bankName: rowData?.bank_name || "",
    accountNumber: rowData?.account_number || "",
    ifscCode: rowData?.ifsc_code || "",
    upiID: rowData?.upi_id || "",
    identityProof: rowData?.id_card || "",
    panCard: rowData?.pan_card || "",
    markSheet10th: rowData?.marksheet10 || "",
    markSheet12th: rowData?.marksheet12 || "",
    staffPhoto: rowData?.photo || "",
    bankDetail: rowData?.passbook || "",
    isMobileEmailVerified: false,
    checkedShifts: [],
    selectedTrainerCategory: "",
    selectedTrainerExperienceLevel: "",
    selectedMorningShiftStartTime: "",
    selectedMorningShiftEndTime: "",
    selectedEveningShiftStartTime: "",
    selectedEveningShiftEndTime: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [fetchedShiftDetails, setFetchedShiftDetails] = useState([]);
  const [isLoadingShifts, setIsLoadingShifts] = useState(false);

  const [modValues, setModValues] = useState({
    isModOpen: false,
    rowData: "",
    cardName: "",
    image: "",
  });

  const [isAddShiftModalOpen, setIsAddShiftModalOpen] = useState(false);
  const [shiftPickerData, setShiftPickerData] = useState({
    startHour: 12,
    startMinute: 0,
    startPeriod: "AM",
    endHour: 12,
    endMinute: 0,
    endPeriod: "AM",
  });
  const [isAddingShift, setIsAddingShift] = useState(false);

  // Multi-gym selector only for cluster_manager (single-gym for sales/club/fitness manager).
  // sales/club/fitness managers pick their gym in Step 1 (Basic Info → "Gym Name") only,
  // no second gym selection during HR approval / edit.
  const isMultiGymShow =
    formValues.selectedStaffType?.value === "cluster_manager";

  const assignRef = (fieldName) => (el) => {
    if (!formRef.current) formRef.current = {};
    if (el) formRef.current[fieldName] = el;
  };

  const onCloseModal = () => {
    setModValues({ isModOpen: false, rowData: "", cardName: "", image: "" });
  };

  const getFileType = (fileUrl) => {
    if (!fileUrl) return "unknown";
    const extension = fileUrl.split(".").pop()?.toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension))
      return "image";
    if (extension === "pdf") return "pdf";
    return "unknown";
  };

  const handleFileView = (fileUrl, fileName) => {
    if (!fileUrl) return;

    const fileType = getFileType(fileUrl);
    if (fileType === "image") {
      setModValues({ isModOpen: true, cardName: "doc-image", image: fileUrl });
    } else {
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileName || "document";
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const fetchShiftDetails = useCallback(async () => {
    if (!rowData?.shift_id || !userInfoData?.token) return;

    setIsLoadingShifts(true);
    try {
      const filters = {
        page: 1,
        limit: 1000,
        status: "active",
      };

      const result = await dispatch(
        fetchReceptionistShiftsData({
          filters: filters,
          token: userInfoData?.token,
        })
      );

      if (result?.payload && Array.isArray(result.payload)) {
        const shiftIds = rowData.shift_id.split(",");
        const matchingShifts = result.payload.filter((shift) =>
          shiftIds.includes(shift.value)
        );

        setFetchedShiftDetails(matchingShifts);
      }
    } catch (error) {
      console.error("Error fetching shift details:", error);
    } finally {
      setIsLoadingShifts(false);
    }
  }, [rowData?.shift_id, userInfoData?.token]);

  const resetShiftPicker = () => {
    setShiftPickerData({
      startHour: 12,
      startMinute: 0,
      startPeriod: "AM",
      endHour: 12,
      endMinute: 0,
      endPeriod: "AM",
    });
  };

  const openAddShiftModal = () => {
    resetShiftPicker();
    setIsAddShiftModalOpen(true);
  };

  const closeAddShiftModal = () => {
    if (isAddingShift) return;
    setIsAddShiftModalOpen(false);
    resetShiftPicker();
  };

  const to24Hour = (hour12, minute, period) => {
    let h = Number(hour12);
    if (period === "AM" && h === 12) h = 0;
    else if (period === "PM" && h !== 12) h = h + 12;
    return `${String(h).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
  };

  const handleAddShiftSave = async () => {
    const {
      startHour,
      startMinute,
      startPeriod,
      endHour,
      endMinute,
      endPeriod,
    } = shiftPickerData;
    const shift_start = to24Hour(startHour, startMinute, startPeriod);
    const shift_end = to24Hour(endHour, endMinute, endPeriod);

    if (shift_start === shift_end) {
      toast.error("Start time and end time cannot be the same");
      return;
    }
    const token = userInfoData?.token || "";
    if (!token) {
      toast.error("Authentication token missing");
      return;
    }
    try {
      setIsAddingShift(true);
      const res = await addShiftAPI({ shift_start, shift_end }, token);
      if (res?.status === true || res?.status === 1) {
        toast.success(res?.message || "Shift added successfully");
        setIsAddShiftModalOpen(false);
        resetShiftPicker();
        dispatch(fetchReceptionistShiftsData({ filters: {}, token }));
      } else {
        toast.error(res?.message || "Failed to add shift");
      }
    } catch (error) {
      console.error("handleAddShiftSave=> ", error);
      toast.error("Something went wrong while adding shift");
    } finally {
      setIsAddingShift(false);
    }
  };

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = value;

    if (name === "staffMobile" || name === "staffEmergencyContactNumber") {
      newValue = value.replace(/\D/g, "").slice(0, 10);
    }
    if (name === "pinCode") {
      newValue = value.replace(/\D/g, "").slice(0, 6);
    }

    const file = type === "file" ? e.target.files[0] : null;

    setFormValues((prev) => {
      if (type === "checkbox" && name === "checkedShifts") {
        const updatedShifts = checked
          ? [...prev.checkedShifts, value]
          : prev.checkedShifts.filter((shift) => shift !== value);

        return {
          ...prev,
          checkedShifts: updatedShifts,
        };
      } else {
        return {
          ...prev,
          [name]:
            type === "checkbox" ? checked : type === "file" ? file : newValue,
        };
      }
    });
  };

  const validateForm = (formValues) => {
    let errors = {};

    if (isReOnboard) {
      // if (
      //   formValues.selectedStaffType?.value !== "cluster_manager" &&
      //   formValues.selectedStaffType?.value !== "fitness_manager" &&
      //   !formValues.selectedGym
      // ) {
      //   errors.selectedGym = "Required!";
      // }

      // if (
      //   (formValues.selectedStaffType?.value === "cluster_manager" ||
      //     formValues.selectedStaffType?.value === "fitness_manager") &&
      //   formValues.selectedGyms?.length === 0
      // ) {
      //   errors.selectedGyms = "Required!";
      // }

      // const salaryValue = formValues.staffSalary
      //   ? parseFloat(formValues.staffSalary)
      //   : 0;

      // if (!formValues.staffSalary || salaryValue <= 0 || isNaN(salaryValue)) {
      //   errors.staffSalary = "Salary must be a valid number greater than 0!";
      // }

      return {};
    } else {
      if (!formValues.selectedStaffType) errors.selectedStaffType = "Required!";

      if (
        formValues.selectedStaffType?.value === "trainer" &&
        formValues.selectedExperties?.length === 0
      ) {
        errors.selectedExperties = "Required!";
      }

      // Single gym required for everyone EXCEPT cluster_manager
      if (
        formValues.selectedStaffType?.value !== "cluster_manager" &&
        !formValues.selectedGym
      ) {
        errors.selectedGym = "Required!";
      }

      // Multi-gym required only for cluster_manager
      if (
        formValues.selectedStaffType?.value === "cluster_manager" &&
        (!formValues.selectedGyms || formValues.selectedGyms.length === 0)
      ) {
        errors.selectedGyms = "Required!";
      }

      if (isApproval && !rowData?.approval_status && !formValues.staffSalary) {
        errors.staffSalary = "Required!";
      }

      if (isApproval) {
        const isTrainer = formValues.selectedStaffType?.value === "trainer";
        const isReceptionist =
          formValues.selectedStaffType?.value === "receptionist";
        const isClusterManager =
          formValues.selectedStaffType?.value === "cluster_manager";
        const isFitnessManager =
          formValues.selectedStaffType?.value === "fitness_manager";
        const isSalesManager =
          formValues.selectedStaffType?.value === "sales_manager";
        const isClubManager =
          formValues.selectedStaffType?.value === "club_manager";

        if (
          (isReceptionist || isFitnessManager || isSalesManager || isClubManager) &&
          (!formValues.checkedShifts || formValues.checkedShifts.length === 0)
        ) {
          errors.checkedShifts = "Please select at least one shift timing!";
        }

        // Multi-gym required only for cluster_manager (sales/club/fitness use single gym)
        if (
          isClusterManager &&
          (!formValues.selectedGyms || formValues.selectedGyms.length === 0)
        ) {
          errors.selectedGyms = "Please select at least one gym!";
        }

        if (isTrainer && !formValues.selectedTrainerCategory) {
          errors.selectedTrainerCategory = "Required!";
        }
        if (isTrainer && !formValues.selectedTrainerExperienceLevel) {
          errors.selectedTrainerExperienceLevel = "Required!";
        }

        if (isTrainer) {
          const {
            selectedMorningShiftStartTime,
            selectedMorningShiftEndTime,
            selectedEveningShiftStartTime,
            selectedEveningShiftEndTime,
          } = formValues;

          const allEmpty =
            !selectedMorningShiftStartTime &&
            !selectedMorningShiftEndTime &&
            !selectedEveningShiftStartTime &&
            !selectedEveningShiftEndTime;

          if (allEmpty) {
            errors.selectedMorningShiftStartTime = "Select Atleast One Shift!";
            errors.selectedEveningShiftStartTime = "Select Atleast One Shift!";
          } else {
            if (
              (selectedMorningShiftStartTime && !selectedMorningShiftEndTime) ||
              (!selectedMorningShiftStartTime && selectedMorningShiftEndTime)
            ) {
              if (!selectedMorningShiftStartTime) {
                errors.selectedMorningShiftStartTime =
                  "Start Time is required if End Time is entered!";
              }
              if (!selectedMorningShiftEndTime) {
                errors.selectedMorningShiftEndTime =
                  "End Time is required if Start Time is entered!";
              }
            }
            if (selectedMorningShiftStartTime && selectedMorningShiftEndTime) {
              if (
                selectedMorningShiftStartTime === selectedMorningShiftEndTime
              ) {
                errors.selectedMorningShiftEndTime =
                  "Start and End time cannot be the same!";
              } else if (
                selectedMorningShiftStartTime > selectedMorningShiftEndTime
              ) {
                errors.selectedMorningShiftEndTime =
                  "End Time must be after Start Time!";
              }
            }

            if (
              (selectedEveningShiftStartTime && !selectedEveningShiftEndTime) ||
              (!selectedEveningShiftStartTime && selectedEveningShiftEndTime)
            ) {
              if (!selectedEveningShiftStartTime) {
                errors.selectedEveningShiftStartTime =
                  "Start Time is required if End Time is entered!";
              }
              if (!selectedEveningShiftEndTime) {
                errors.selectedEveningShiftEndTime =
                  "End Time is required if Start Time is entered!";
              }
            }
            if (selectedEveningShiftStartTime && selectedEveningShiftEndTime) {
              if (
                selectedEveningShiftStartTime === selectedEveningShiftEndTime
              ) {
                errors.selectedEveningShiftEndTime =
                  "Start and End time cannot be the same!";
              } else if (
                selectedEveningShiftStartTime > selectedEveningShiftEndTime
              ) {
                errors.selectedEveningShiftEndTime =
                  "End Time must be after Start Time!";
              }
            }

            if (
              selectedMorningShiftStartTime &&
              selectedMorningShiftEndTime &&
              selectedEveningShiftStartTime &&
              selectedEveningShiftEndTime
            ) {
              if (
                selectedMorningShiftEndTime > selectedEveningShiftStartTime &&
                selectedMorningShiftStartTime < selectedEveningShiftEndTime
              ) {
                errors.selectedMorningShiftEndTime = "Shifts cannot overlap!";
                errors.selectedEveningShiftStartTime = "Shifts cannot overlap!";
              }
            }
          }
        }
      }

      if (!formValues.staffName) errors.staffName = "Required!";

      if (!formValues.staffMobile) {
        errors.staffMobile = "Required!";
      } else if (!/^\d{10}$/.test(formValues.staffMobile)) {
        errors.staffMobile = "Must be exactly 10 digits!";
      }

      if (!formValues.staffEmail) {
        errors.staffEmail = "Required!";
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.staffEmail)) {
        errors.staffEmail = "Invalid email format!";
      } else if (formValues.staffEmail.endsWith("@yopmail.com")) {
        errors.staffEmail = "Yopmail is not allowed!";
      }

      if (!formValues.staffEmergencyContactNumber) {
        errors.staffEmergencyContactNumber = "Required!";
      } else if (!/^\d{10}$/.test(formValues.staffEmergencyContactNumber)) {
        errors.staffEmergencyContactNumber = "Must be exactly 10 digits!";
      }

      if (!formValues.joiningDate) errors.joiningDate = "Required!";

      if (!formValues.staffDob) errors.staffDob = "Required!";

      if (!formValues.fullAddress) errors.fullAddress = "Required!";

      if (!formValues.pinCode) {
        errors.pinCode = "Required!";
      } else if (!/^\d{6}$/.test(formValues.pinCode)) {
        errors.pinCode = "Must be exactly 6 digits!";
      }

      // ===== Banking & Bank Detail fields are optional =====
      // if (!formValues.bankName) errors.bankName = "Required!";
      // if (!formValues.accountNumber) errors.accountNumber = "Required!";
      // if (!formValues.ifscCode) errors.ifscCode = "Required!";

      // Identity Proof and Staff Photo are still mandatory
      if (!isEdit) {
        if (!formValues.identityProof) errors.identityProof = "Required!";
        // if (!formValues.panCard) errors.panCard = "Required!";
        // if (!formValues.markSheet10th) errors.markSheet10th = "Required!";
        // if (!formValues.markSheet12th) errors.markSheet12th = "Required!";
        // if (!formValues.staffPhoto) errors.staffPhoto = "Required!";
        if (!formValues.staffPhoto) errors.staffPhoto = "Required!";
        // if (!formValues.bankDetail) errors.bankDetail = "Required!";
      }
      // ===== End optional fields =====

      return errors;
    }
  };

  const handleSubmitForm = async (
    requestBody,
    isJsonPayload = false,
    isApprove = null
  ) => {
    const method = isEdit && !isReOnboard ? "PUT" : "POST";
    const endpoint = isReOnboard
      ? re_onboard_staff
      : isEdit
      ? update_staff_onboarding
      : add_staff_onboarding;
    const token = userInfoData?.token || "";

    try {
      let result;
      if (isJsonPayload) {
        result = await dispatch(
          commonPostPutApi({ method, endpoint, payload: requestBody, token })
        );
      } else {
        result = await dispatch(
          commonPostPutFormData({ method, endpoint, requestBody, token })
        );
      }

      if (result?.payload?.status) {
        setIsSubmit(true);
        setFormValues(forminitials);
        isEdit && closeModal();
        isEdit && callFunction();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      toast.error("Error making request. Please try again.");
    }
  };

  // const handleSubmitForm = async (payload) => {
  //   const method = isEdit && !isReOnboard ? "PUT" : "POST";
  //   const endpoint = isReOnboard
  //     ? re_onboard_staff
  //     : isEdit
  //     ? update_staff_onboarding
  //     : add_staff_onboarding;
  //   const token = userInfoData?.token || "";

  //   setIsSubmit(false);

  //   try {
  //     const result = await dispatch(
  //       commonPostPutApi({ method, endpoint, payload, token })
  //     );

  //     console.log("result=> ", result);

  //     if (result?.payload?.status) {
  //       setIsSubmit(true);
  //       setFormValues(forminitials);
  //       isEdit && closeModal();
  //       isEdit && callFunction();
  //     } else {
  //       const errorMessage = result?.error?.message || result?.payload?.message;
  //       toast.error(errorMessage || "Something Went Wrong!");
  //     }
  //   } catch (error) {
  //     console.error("Error making POST request:", error);
  //   }
  // };

  const onSubmit = (isApprove) => {
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (isReOnboard) {
        const salaryValue = formValues.staffSalary
          ? parseFloat(formValues.staffSalary)
          : 0;
        const jsonPayload = {
          mobile: formValues.staffMobile,
          salary: isNaN(salaryValue) || salaryValue <= 0 ? 1 : salaryValue,
          gym_ids: [formValues.selectedGym?.value],
        };

        showConfirmAlert(
          () => handleSubmitForm(jsonPayload, true, null),
          `Are you sure you want to re-onboard this employee?`,
          "Confirm Re-onboarding",
          "Re-Onboard"
        );
      } else {
        const expertiseIds =
          formValues.selectedExperties?.length > 0
            ? formValues.selectedExperties.map((item) => item?.value).join(",")
            : "";
        const allGyms =
          formValues.selectedGyms?.length > 0
            ? formValues.selectedGyms.map((item) => item?.value).join(",")
            : "";

        const staffType = formValues.selectedStaffType?.value || "";

        const userData = {
          photo: formValues.staffPhoto || "",
          name: formValues.staffName || "",
          email: formValues.staffEmail || "",
          mobile: formValues.staffMobile || "",
          account_type: staffType,
          emergency_contact: formValues.staffEmergencyContactNumber || "",
          joining_date: formValues.joiningDate || "",
          dob: formValues.staffDob || "",
          address: formValues.fullAddress || "",
          postal_code: formValues.pinCode || "",
          bank_name: formValues.bankName || "",
          account_number: formValues.accountNumber || "",
          ifsc_code: formValues.ifscCode?.toLocaleUpperCase() || "",
          upi_id: formValues.upiID || "",
          id_card: formValues.identityProof || "",
          pan_card: formValues.panCard || "",
          gym_id: formValues.selectedGym?.value || "",
          // cluster_manager uses multi-select; sales/club/fitness use single gym (selectedGym)
          cm_gyms: staffType === "cluster_manager" ? allGyms : "",
          fm_gyms:
            staffType === "fitness_manager"
              ? formValues.selectedGym?.value || ""
              : "",
          sm_gyms:
            staffType === "sales_manager"
              ? formValues.selectedGym?.value || ""
              : "",
          clm_gyms:
            staffType === "club_manager"
              ? formValues.selectedGym?.value || ""
              : "",
          expertise: expertiseIds,
          expertise_id: expertiseIds,
          marksheet10: formValues.markSheet10th || "",
          marksheet12: formValues.markSheet12th || "",
          passbook: formValues.bankDetail || "",
          salary: formValues.staffSalary || "",
          status: "active",
          allow_duplicate: 0,
          payrole_type: "",
          approval_status: isApproval
            ? isApprove
            : isEdit
            ? rowData?.approval_status
            : 0,
          is_update: isApproval ? 0 : isEdit ? 1 : "",
          is_club_manager:
            formValues.selectedStaffType?.label === "Club Manager" ? 1 : 0,
          shift_id: formValues.checkedShifts?.toString() || "",
          trainer_category_id: formValues.selectedTrainerCategory?.value || "",
          trainer_exp_lvl:
            formValues.selectedTrainerExperienceLevel?.value || "",
          morning_shift_start: formValues.selectedMorningShiftStartTime || "",
          morning_shift_end: formValues.selectedMorningShiftEndTime || "",
          evening_shift_start: formValues.selectedEveningShiftStartTime || "",
          evening_shift_end: formValues.selectedEveningShiftEndTime || "",
        };

        const formData = new FormData();
        for (const key in userData) {
          if (userData.hasOwnProperty(key)) {
            if (userData[key] instanceof File) {
              formData.append(key, userData[key]);
            } else {
              formData.append(key, userData[key].toString());
            }
          }
        }

        if (isEdit) formData.append("uid", rowData.uid);

        showConfirmAlert(
          () => handleSubmitForm(formData, false, isApprove),
          `Are you sure!`,
          "Edit Form",
          "Submit Form"
        );
      }
    } else if (formRef.current) {
      const firstErrorField = Object.keys(errors).find(
        (field) => formRef.current[field]
      );
      if (firstErrorField) {
        formRef.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  const handleViewOfferLetter = () => {
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setModValues({
        isModOpen: true,
        cardName: "offer_letter",
        rowData: {
          name: formValues.staffName,
          address: formValues.fullAddress,
          account_type: formValues.selectedStaffType?.value,
          joining_date: formValues.joiningDate,
          salary: formValues.staffSalary,
        },
      });
    } else if (formRef.current) {
      const firstErrorField = Object.keys(errors).find(
        (field) => formRef.current[field]
      );
      if (firstErrorField) {
        formRef.current[firstErrorField].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }
  };

  useEffect(
    () => {
      if ((isEdit || isApproval) && rowData) {
        setFormValues((prevs) => ({
          ...prevs,
          selectedStaffType: rowData?.account_type
            ? {
                value: rowData.account_type,
                label: rowData.account_type?.replace(/_/g, " "),
              }
            : "",
          selectedGym:
            rowData?.gym_id && rowData?.gym_name
              ? { value: rowData.gym_id, label: rowData.gym_name }
              : "",
          selectedGyms:
            rowData?.gyms_info?.length > 0
              ? gymData.filter((gym) =>
                  rowData.gyms_info.some((info) => info.user_id === gym.value)
                )
              : [],
          staffName: rowData?.name || "",
          staffMobile: rowData?.mobile || "",
          staffEmail: rowData?.email || "",
          staffEmergencyContactNumber: rowData?.emergency_contact || "",
          joiningDate: rowData?.joining_date || "",
          staffDob: rowData?.dob || "",
          selectedExperties: getSelectedExperties(rowData, trainerExperties),
          fullAddress: rowData?.address || "",
          staffSalary:
            rowData?.salary && !isNaN(Number(rowData.salary))
              ? rowData.salary
              : "",
          pinCode: rowData?.postal_code || "",
          bankName: rowData?.bank_name || "",
          accountNumber: rowData?.account_number || "",
          ifscCode: rowData?.ifsc_code || "",
          upiID: rowData?.upi_id || "",
          identityProof: rowData?.id_card || "",
          panCard: rowData?.pan_card || "",
          markSheet10th: rowData?.marksheet10 || "",
          markSheet12th: rowData?.marksheet12 || "",
          staffPhoto: rowData?.photo || "",
          bankDetail: rowData?.passbook || "",
          selectedMorningShiftStartTime: rowData?.morning_shift_start || "",
          selectedMorningShiftEndTime: rowData?.morning_shift_end || "",
          selectedEveningShiftStartTime: rowData?.evening_shift_start || "",
          selectedEveningShiftEndTime: rowData?.evening_shift_end || "",
          checkedShifts: rowData?.shift_id ? rowData.shift_id.split(",") : [],
        }));
      }
    },
    [
      // trainerExperties, gymData,
      // isApproval, isEdit, rowData
    ]
  );

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token || ""));

    const filters = { page: 1, limit: 1000, status: "active" };
    dispatch(
      fetchTrainerExpertiesData({ filters, token: userInfoData?.token || "" })
    );
  }, []);

  useEffect(() => {
    if (isApproval || isEdit) {
      const staffType =
        formValues.selectedStaffType?.value || rowData?.account_type;

      if (staffType) {
        const filters = { page: 1, limit: 1000, status: "active" };
        const token = userInfoData?.token || "";

        if (staffType === "trainer") {
          dispatch(fetchTrainerCategoryData({ filters, token }));
          dispatch(fetchTrainerExperienceLevelData({ filters, token }));
        }

        if (
          ["receptionist", "fitness_manager", "sales_manager", "club_manager"].includes(
            staffType
          )
        ) {
          dispatch(fetchReceptionistShiftsData({ filters, token }));
        }

        if (
          staffType === "cluster_manager" ||
          staffType === "fitness_manager" ||
          staffType === "sales_manager" ||
          staffType === "club_manager"
        ) {
          dispatch(fetchGymData(token));
        }
      }
    }
  }, [formValues.selectedStaffType?.value]);

  useEffect(() => {
    if (
      isEdit &&
      rowData?.shift_id &&
      (formValues.selectedStaffType?.value === "receptionist" ||
        formValues.selectedStaffType?.value === "sales_manager")
      // || formValues.selectedStaffType?.value === "cluster_manager"
      // || formValues.selectedStaffType?.value === "fitness_manager"
    ) {
      fetchShiftDetails();
    }
  }, [formValues.selectedStaffType?.value]);

  console.log("formErrors=> ", formErrors);

  return (
    <HelmetWrapper title={`WTF: Staff ${isEdit ? "Edit" : "Onboarding"}`}>
      <div className="staff-onboarding-container">
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div className="modal-wrapper-no-padding">
            <div
              className={`createNewCTOModalContainer ${
                modValues.cardName === "onboarding"
                  ? "mod-width-50p"
                  : modValues.cardName === "doc-image"
                  ? "modal-container-abs"
                  : ""
              }`}
            >
              <ModalHeadAndClose
                title={
                  modValues.cardName === "offer_letter"
                    ? "Employee Offer Letter Preview"
                    : ""
                }
                onClose={onCloseModal}
              />
              <div className="grayLine"></div>
              {modValues.cardName === "offer_letter" ? (
                <ViewOfferLetter rowData={modValues.rowData} />
              ) : modValues.cardName === "doc-image" ? (
                <div className="discussionModalMessage mt30">
                  <img src={modValues.image} alt={modValues.image} />
                </div>
              ) : null}
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={isAddShiftModalOpen}
          onRequestClose={closeAddShiftModal}
          contentLabel="Add Shift"
          ariaHideApp={false}
        >
          <div className="modal-wrapper-no-padding">
            <div
              className="createNewCTOModalContainer mod-width-50p"
              style={{ minWidth: 620, maxWidth: 720 }}
            >
              <ModalHeadAndClose
                title="Add New Shift"
                onClose={closeAddShiftModal}
              />
              <div className="grayLine"></div>
              <div style={{ padding: "24px 28px" }}>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 24,
                  }}
                >
                  {[
                    {
                      label: "Start Time",
                      hourKey: "startHour",
                      minuteKey: "startMinute",
                      periodKey: "startPeriod",
                    },
                    {
                      label: "End Time",
                      hourKey: "endHour",
                      minuteKey: "endMinute",
                      periodKey: "endPeriod",
                    },
                  ].map((cfg) => (
                    <div key={cfg.label}>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 600,
                          color: "#374151",
                          marginBottom: 8,
                        }}
                      >
                        {cfg.label}{" "}
                        <span style={{ color: "#ef4444" }}>*</span>
                      </div>
                      <div
                        style={{
                          background:
                            "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                          color: "#fff",
                          padding: "20px 22px",
                          borderRadius: 10,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          boxShadow: "0 2px 8px rgba(220,38,38,0.25)",
                        }}
                      >
                        <div
                          style={{
                            fontSize: 44,
                            fontWeight: 700,
                            letterSpacing: 1,
                            lineHeight: 1,
                          }}
                        >
                          {String(shiftPickerData[cfg.hourKey]).padStart(
                            2,
                            "0"
                          )}
                          <span style={{ opacity: 0.6, margin: "0 4px" }}>
                            :
                          </span>
                          {String(shiftPickerData[cfg.minuteKey]).padStart(
                            2,
                            "0"
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: 4,
                          }}
                        >
                          {["AM", "PM"].map((p) => {
                            const active =
                              shiftPickerData[cfg.periodKey] === p;
                            return (
                              <button
                                type="button"
                                key={p}
                                onClick={() =>
                                  setShiftPickerData((prev) => ({
                                    ...prev,
                                    [cfg.periodKey]: p,
                                  }))
                                }
                                style={{
                                  cursor: "pointer",
                                  padding: "4px 12px",
                                  fontSize: 13,
                                  fontWeight: 700,
                                  border: "none",
                                  borderRadius: 4,
                                  background: active
                                    ? "rgba(255,255,255,0.95)"
                                    : "transparent",
                                  color: active ? "#dc2626" : "#fff",
                                  opacity: active ? 1 : 0.7,
                                  minWidth: 44,
                                }}
                              >
                                {p}
                              </button>
                            );
                          })}
                        </div>
                      </div>
                      <div
                        style={{
                          marginTop: 14,
                          display: "flex",
                          gap: 12,
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontSize: 11,
                              color: "#6b7280",
                              marginBottom: 4,
                              fontWeight: 500,
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                            }}
                          >
                            Hour
                          </div>
                          <select
                            value={shiftPickerData[cfg.hourKey]}
                            onChange={(e) =>
                              setShiftPickerData((prev) => ({
                                ...prev,
                                [cfg.hourKey]: Number(e.target.value),
                              }))
                            }
                            style={{
                              width: "100%",
                              padding: "9px 10px",
                              border: "1px solid #d1d5db",
                              borderRadius: 6,
                              fontSize: 14,
                              background: "#fff",
                            }}
                          >
                            {Array.from({ length: 12 }, (_, i) => i + 1).map(
                              (h) => (
                                <option key={h} value={h}>
                                  {String(h).padStart(2, "0")}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                        <div style={{ flex: 1 }}>
                          <div
                            style={{
                              fontSize: 11,
                              color: "#6b7280",
                              marginBottom: 4,
                              fontWeight: 500,
                              textTransform: "uppercase",
                              letterSpacing: 0.5,
                            }}
                          >
                            Minute
                          </div>
                          <select
                            value={shiftPickerData[cfg.minuteKey]}
                            onChange={(e) =>
                              setShiftPickerData((prev) => ({
                                ...prev,
                                [cfg.minuteKey]: Number(e.target.value),
                              }))
                            }
                            style={{
                              width: "100%",
                              padding: "9px 10px",
                              border: "1px solid #d1d5db",
                              borderRadius: 6,
                              fontSize: 14,
                              background: "#fff",
                            }}
                          >
                            {Array.from({ length: 60 }, (_, i) => i).map(
                              (m) => (
                                <option key={m} value={m}>
                                  {String(m).padStart(2, "0")}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    marginTop: 28,
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: 10,
                  }}
                >
                  <button
                    type="button"
                    onClick={closeAddShiftModal}
                    disabled={isAddingShift}
                    className="staff-onboarding-btn staff-onboarding-btn-back"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    onClick={handleAddShiftSave}
                    disabled={isAddingShift}
                    className="staff-onboarding-btn staff-onboarding-btn-primary"
                  >
                    {isAddingShift ? (
                      <div className="staff-onboarding-loading-spinner" />
                    ) : (
                      "Save Shift"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <div className="staff-onboarding-header">
          <div className="staff-onboarding-header-content">
            <div className="staff-onboarding-header-info">
              <h1 className="staff-onboarding-title">
                {isReOnboard
                  ? "Re-Onboard Employee"
                  : isApproval
                  ? "Onboarding Request"
                  : "Staff Onboard"}
              </h1>
              <p className="staff-onboarding-subtitle">
                {isReOnboard
                  ? "Update employee information for re-onboarding"
                  : "Complete the form below to onboard"}
              </p>
            </div>
            <div className="staff-onboarding-header-actions">
              {!isSubmit && isApproval && (
                <button
                  type="button"
                  onClick={handleViewOfferLetter}
                  className="staff-onboarding-btn staff-onboarding-btn-secondary"
                  disabled={postPutLoadingFormData}
                >
                  View Offer Letter
                </button>
              )}
              <button
                type="button"
                onClick={
                  isSubmit
                    ? () => {
                        setIsSubmit(false);
                        if (closeModal) closeModal();
                        if (callFunction) callFunction();
                      }
                    : () => (isApproval ? onSubmit(1) : onSubmit())
                }
                className={`staff-onboarding-btn ${
                  isSubmit
                    ? "staff-onboarding-btn-back"
                    : "staff-onboarding-btn-primary"
                }`}
                disabled={postPutLoadingFormData}
              >
                {postPutLoadingFormData ? (
                  <div className="staff-onboarding-loading-spinner" />
                ) : (
                  <>
                    {!isSubmit && <CheckIcon color="#fff" />}
                    {isSubmit
                      ? "Back"
                      : isReOnboard
                      ? "Re-Onboard"
                      : isApproval
                      ? "Approve"
                      : isEdit
                      ? "Update"
                      : "Submit"}
                  </>
                )}
              </button>
              {!isSubmit && isApproval && (
                <button
                  type="button"
                  onClick={() => onSubmit(-1)}
                  className="staff-onboarding-btn staff-onboarding-btn-danger"
                  disabled={postPutLoadingFormData}
                >
                  <XIcon color="#fff" />
                  Reject
                </button>
              )}
              {isEdit && (
                <button
                  type="button"
                  onClick={closeModal}
                  className="staff-onboarding-btn staff-onboarding-btn-ghost"
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>

        {isSubmit ? (
          <div className="staff-onboarding-success-container">
            <SubmissionThankYouPage setIsFormSubmitted={setIsSubmit} />
          </div>
        ) : (
          <div className="staff-onboarding-content">
            {isReOnboard && (
              <div className="staff-onboarding-warning-banner">
                <AlertIcon color="#F59E0B" />
                <div className="staff-onboarding-warning-content">
                  <strong>Warning:</strong> You are re-onboarding this employee.
                  Only salary and gym can be modified during re-onboarding.
                  After re-onboarding, you can modify other details of the
                  staff.
                </div>
              </div>
            )}

            <form className="staff-onboarding-form staff-onboarding-form-container">
              {!isEdit && !isApproval && (
                <ContactVerificationSection
                  formValues={formValues}
                  setFormValues={setFormValues}
                  formErrors={formErrors}
                  setFormErrors={setFormErrors}
                  onChangeInput={onChangeInput}
                  userInfoData={userInfoData}
                />
              )}

              {(isEdit || isApproval) && (
                <div className="staff-onboarding-form-section">
                  <div className="staff-onboarding-section-header">
                    <h3 className="staff-onboarding-section-title">
                      Contact Information
                    </h3>
                    <p className="staff-onboarding-section-subtitle">
                      Primary contact details
                    </p>
                  </div>

                  <div className="staff-onboarding-section-content">
                    <div className="staff-onboarding-form-grid grid-2">
                      <FormInput
                        icon={CallIcon}
                        label="Mobile Number"
                        name="staffMobile"
                        type="tel"
                        placeholder="Enter 10-digit mobile number"
                        value={formValues.staffMobile}
                        onChange={onChangeInput}
                        error={formErrors?.staffMobile}
                        disabled={true}
                        required={true}
                        onRef={assignRef("staffMobile")}
                      />

                      <FormInput
                        icon={EmailIcon}
                        label="Email Address"
                        name="staffEmail"
                        type="email"
                        placeholder="Enter email address"
                        value={formValues.staffEmail}
                        onChange={onChangeInput}
                        error={formErrors?.staffEmail}
                        disabled={true}
                        required={true}
                        onRef={assignRef("staffEmail")}
                      />
                    </div>
                  </div>
                </div>
              )}

              {(isEdit || isApproval || formValues.isMobileEmailVerified) && (
                <>
                  <BasicInformationSection
                    formValues={formValues}
                    setFormValues={setFormValues}
                    formErrors={formErrors}
                    onChangeInput={onChangeInput}
                    assignRef={assignRef}
                    isReOnboard={isReOnboard}
                    isApproval={isApproval}
                    isAdmin={isAdmin}
                    rowData={rowData}
                    onboarding_staff_types={onboarding_staff_types}
                    gymData={gymData}
                    trainerExperties={trainerExperties}
                  />

                  <BankingInformationSection
                    formValues={formValues}
                    onChangeInput={onChangeInput}
                    formErrors={formErrors}
                    assignRef={assignRef}
                    isReOnboard={isReOnboard}
                  />

                  <DocumentUploadSection
                    formValues={formValues}
                    onChangeInput={onChangeInput}
                    formErrors={formErrors}
                    assignRef={assignRef}
                    isReOnboard={isReOnboard}
                    isEdit={isEdit}
                    isApproval={isApproval}
                    handleFileView={handleFileView}
                  />

                  {(isApproval || isEdit) && (
                    <div className="staff-onboarding-form-section">
                      <div className="staff-onboarding-section-header">
                        <h3 className="staff-onboarding-section-title">
                          {isEdit ? "Update Settings" : "HR Approval Settings"}
                        </h3>
                        <p className="staff-onboarding-section-subtitle">
                          {isEdit
                            ? "Update shift timing and trainer details"
                            : "Configure shift timing and trainer details for staff onboarding"}
                        </p>
                      </div>

                      <div className="staff-onboarding-section-content">
                        <div className="staff-onboarding-form-grid grid-3">
                          {isMultiGymShow && (
                            <div className="staff-onboarding-form-group staff-onboarding-full-width">
                              <label className="staff-onboarding-form-label">
                                <span className="staff-onboarding-label-text">
                                  Select Gyms{" "}
                                  <span className="staff-onboarding-required">
                                    *
                                  </span>
                                </span>
                              </label>
                              <div
                                className={`commonWrapper ${
                                  formErrors.selectedGyms ? "formError" : ""
                                }`}
                                ref={assignRef("selectedGyms")}
                              >
                                <MultiSelect
                                  options={
                                    gymData && gymData?.length > 0
                                      ? gymData
                                      : []
                                  }
                                  state={formValues.selectedGyms || []}
                                  isShowList={true}
                                  setState={(selectedValue) => {
                                    setFormValues((prevs) => ({
                                      ...prevs,
                                      selectedGyms: selectedValue,
                                    }));
                                    if (formErrors.selectedGyms) {
                                      setFormErrors((prev) => ({
                                        ...prev,
                                        selectedGyms: "",
                                      }));
                                    }
                                  }}
                                  name="Select Gyms"
                                  placeholder="Select multiple gyms"
                                />
                              </div>
                              {formErrors.selectedGyms && (
                                <div className="staff-onboarding-error-message">
                                  <AlertIcon color="#EF4444" />
                                  <span>{formErrors.selectedGyms}</span>
                                </div>
                              )}
                            </div>
                          )}

                          {isEdit &&
                            formValues.selectedStaffType?.value ===
                              "receptionist" && (
                              <div className="staff-onboarding-form-group staff-onboarding-full-width">
                                <label className="staff-onboarding-form-label">
                                  <span className="staff-onboarding-label-text">
                                    Current Shift Timing
                                  </span>
                                </label>
                                <div className="staff-onboarding-shift-container">
                                  {isLoadingShifts ? (
                                    <span className="info">
                                      Loading shift details...
                                    </span>
                                  ) : fetchedShiftDetails &&
                                    fetchedShiftDetails.length > 0 ? (
                                    <div className="shift-display-grid">
                                      {fetchedShiftDetails.map(
                                        (shift, index) => (
                                          <div
                                            key={index}
                                            className="shift-display-card"
                                          >
                                            {shift?.info?.shift_start &&
                                            shift?.info?.shift_end
                                              ? `${convertTo12HourFormat(
                                                  shift.info.shift_start
                                                )} - ${convertTo12HourFormat(
                                                  shift.info.shift_end
                                                )}`
                                              : shift?.label ||
                                                "Shift timing not available"}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  ) : (
                                    <span className="info">
                                      Shift timing information not available
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}

                          {[
                            "receptionist",
                            "fitness_manager",
                            "sales_manager",
                            "club_manager",
                          ].includes(
                            formValues.selectedStaffType?.value
                          ) && (
                            <div className="staff-onboarding-form-group staff-onboarding-full-width">
                              <label className="staff-onboarding-form-label">
                                <span className="staff-onboarding-label-text">
                                  Choose Shift Time{" "}
                                  <span className="staff-onboarding-required">
                                    *
                                  </span>
                                </span>
                              </label>
                              <div
                                className={`staff-onboarding-shift-container ${
                                  formErrors.checkedShifts ? "formError" : ""
                                }`}
                                ref={assignRef("checkedShifts")}
                              >
                                {(() => {
                                  try {
                                    const sortedShifts =
                                      sortShiftsByStartTime(receptionistShifts);

                                    if (sortedShifts.length === 0) {
                                      return (
                                        <span className="info">
                                          No shifts available
                                        </span>
                                      );
                                    }

                                    return sortedShifts.map((shift, index) => {
                                      const isChecked = Array.isArray(
                                        formValues?.checkedShifts
                                      )
                                        ? formValues.checkedShifts.includes(
                                            shift?.value
                                          )
                                        : false;

                                      return (
                                        <label
                                          className={`checkboxLabel ${
                                            isChecked ? "active" : ""
                                          }`}
                                          key={shift?.value || index}
                                        >
                                          <input
                                            type="checkbox"
                                            name="checkedShifts"
                                            value={shift?.value || ""}
                                            checked={isChecked}
                                            onChange={onChangeInput}
                                          />
                                          {shift?.label || "Unknown Shift"}
                                        </label>
                                      );
                                    });
                                  } catch (error) {
                                    console.error(
                                      "Error rendering shifts:",
                                      error
                                    );
                                    return (
                                      <span className="info">
                                        Error loading shifts
                                      </span>
                                    );
                                  }
                                })()}
                              </div>
                              <div style={{ marginTop: 8 }}>
                                <button
                                  type="button"
                                  onClick={openAddShiftModal}
                                  className="staff-onboarding-btn staff-onboarding-btn-secondary"
                                  style={{
                                    padding: "6px 12px",
                                    fontSize: 13,
                                  }}
                                >
                                  + Add Shift
                                </button>
                              </div>
                              {formErrors.checkedShifts && (
                                <div className="staff-onboarding-error-message">
                                  <AlertIcon color="#EF4444" />
                                  <span>{formErrors.checkedShifts}</span>
                                </div>
                              )}
                            </div>
                          )}

                          {formValues.selectedStaffType?.value ===
                            "trainer" && (
                            <div className="staff-onboarding-form-group">
                              <label className="staff-onboarding-form-label">
                                <span className="staff-onboarding-label-text">
                                  Trainer Category{" "}
                                  <span className="staff-onboarding-required">
                                    *
                                  </span>
                                </span>
                              </label>
                              <div
                                className={`commonWrapper ${
                                  formErrors.selectedTrainerCategory
                                    ? "formError"
                                    : ""
                                }`}
                                ref={assignRef("selectedTrainerCategory")}
                              >
                                <SelectDropdown
                                  options={
                                    trainerCategories &&
                                    trainerCategories?.length > 0
                                      ? trainerCategories
                                      : []
                                  }
                                  selectedOption={
                                    formValues.selectedTrainerCategory
                                  }
                                  setSelectedOption={(selectedValue) => {
                                    setFormValues((prevs) => ({
                                      ...prevs,
                                      selectedTrainerCategory: selectedValue,
                                    }));
                                    if (formErrors.selectedTrainerCategory) {
                                      setFormErrors((prev) => ({
                                        ...prev,
                                        selectedTrainerCategory: "",
                                      }));
                                    }
                                  }}
                                  name="Category"
                                />
                              </div>
                              {formErrors.selectedTrainerCategory && (
                                <div className="staff-onboarding-error-message">
                                  <AlertIcon color="#EF4444" />
                                  <span>
                                    {formErrors.selectedTrainerCategory}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}

                          {formValues.selectedStaffType?.value ===
                            "trainer" && (
                            <div className="staff-onboarding-form-group">
                              <label className="staff-onboarding-form-label">
                                <span className="staff-onboarding-label-text">
                                  Trainer Experience Level{" "}
                                  <span className="staff-onboarding-required">
                                    *
                                  </span>
                                </span>
                              </label>
                              <div
                                className={`commonWrapper ${
                                  formErrors.selectedTrainerExperienceLevel
                                    ? "formError"
                                    : ""
                                }`}
                                ref={assignRef(
                                  "selectedTrainerExperienceLevel"
                                )}
                              >
                                <SelectDropdown
                                  options={
                                    trainerExperienceLevel &&
                                    trainerExperienceLevel?.length > 0
                                      ? trainerExperienceLevel
                                      : []
                                  }
                                  selectedOption={
                                    formValues.selectedTrainerExperienceLevel
                                  }
                                  setSelectedOption={(selectedValue) => {
                                    setFormValues((prevs) => ({
                                      ...prevs,
                                      selectedTrainerExperienceLevel:
                                        selectedValue,
                                    }));
                                    if (
                                      formErrors.selectedTrainerExperienceLevel
                                    ) {
                                      setFormErrors((prev) => ({
                                        ...prev,
                                        selectedTrainerExperienceLevel: "",
                                      }));
                                    }
                                  }}
                                  name="Experience Level"
                                />
                              </div>
                              {formErrors.selectedTrainerExperienceLevel && (
                                <div className="staff-onboarding-error-message">
                                  <AlertIcon color="#EF4444" />
                                  <span>
                                    {formErrors.selectedTrainerExperienceLevel}
                                  </span>
                                </div>
                              )}
                            </div>
                          )}

                          {formValues.selectedStaffType?.value ===
                            "trainer" && (
                            <div className="staff-onboarding-form-group staff-onboarding-full-width">
                              <label className="staff-onboarding-form-label">
                                <span className="staff-onboarding-label-text">
                                  Trainer Shift Timing{" "}
                                  <span className="staff-onboarding-required">
                                    *
                                  </span>
                                </span>
                              </label>
                              <div className="trainer-shift-timing-container">
                                <div className="shift-timing-table">
                                  <div className="shift-timing-header">
                                    <div className="shift-name">Shift Name</div>
                                    <div className="shift-time">Start Time</div>
                                    <div className="shift-time">End Time</div>
                                  </div>

                                  <div className="shift-timing-row">
                                    <label className="shift-label">
                                      Morning
                                    </label>
                                    <input
                                      type="time"
                                      placeholder="Enter Start Time"
                                      className={`staff-onboarding-time-input ${
                                        formErrors?.selectedMorningShiftStartTime
                                          ? "formError"
                                          : ""
                                      }`}
                                      name="selectedMorningShiftStartTime"
                                      value={
                                        formValues.selectedMorningShiftStartTime
                                      }
                                      onChange={onChangeInput}
                                    />
                                    <input
                                      type="time"
                                      placeholder="Enter End Time"
                                      className={`staff-onboarding-time-input ${
                                        formErrors?.selectedMorningShiftEndTime
                                          ? "formError"
                                          : ""
                                      }`}
                                      name="selectedMorningShiftEndTime"
                                      value={
                                        formValues.selectedMorningShiftEndTime
                                      }
                                      onChange={onChangeInput}
                                    />
                                  </div>

                                  <div className="shift-timing-row">
                                    <label className="shift-label">
                                      Evening
                                    </label>
                                    <input
                                      type="time"
                                      placeholder="Enter Start Time"
                                      className={`staff-onboarding-time-input ${
                                        formErrors?.selectedEveningShiftStartTime
                                          ? "formError"
                                          : ""
                                      }`}
                                      name="selectedEveningShiftStartTime"
                                      value={
                                        formValues.selectedEveningShiftStartTime
                                      }
                                      onChange={onChangeInput}
                                    />
                                    <input
                                      type="time"
                                      placeholder="Enter End Time"
                                      className={`staff-onboarding-time-input ${
                                        formErrors?.selectedEveningShiftEndTime
                                          ? "formError"
                                          : ""
                                      }`}
                                      name="selectedEveningShiftEndTime"
                                      value={
                                        formValues.selectedEveningShiftEndTime
                                      }
                                      onChange={onChangeInput}
                                    />
                                  </div>
                                </div>

                                {(formErrors.selectedMorningShiftStartTime ||
                                  formErrors.selectedMorningShiftEndTime ||
                                  formErrors.selectedEveningShiftStartTime ||
                                  formErrors.selectedEveningShiftEndTime) && (
                                  <div className="staff-onboarding-error-message">
                                    <AlertIcon color="#EF4444" />
                                    <span>
                                      {formErrors.selectedMorningShiftStartTime ||
                                        formErrors.selectedMorningShiftEndTime ||
                                        formErrors.selectedEveningShiftStartTime ||
                                        formErrors.selectedEveningShiftEndTime}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </form>
          </div>
        )}
      </div>
    </HelmetWrapper>
  );
};

export default OnBoardingFormLanding;
